import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { Copy, Check } from "lucide-react";
import { useState } from "react";

function CodeBlock({ inline, className, children, ...props }) {
  const [copied, setCopied] = useState(false);
  const match = /language-(\w+)/.exec(className || "");
  const text = String(children).replace(/\n$/, "");

  if (inline) {
    return (
      <code className={className} {...props}>
        {children}
      </code>
    );
  }

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {}
  };

  return (
    <div className="relative my-3 group">
      <div className="flex items-center justify-between bg-black/70 border border-white/5 border-b-0 rounded-t-lg px-3 py-1.5 text-[11px] text-white/50">
        <span className="font-mono uppercase tracking-wider">
          {match?.[1] || "code"}
        </span>
        <button
          onClick={copy}
          className="flex items-center gap-1 hover:text-white transition"
        >
          {copied ? (
            <>
              <Check className="h-3 w-3" /> Copied
            </>
          ) : (
            <>
              <Copy className="h-3 w-3" /> Copy
            </>
          )}
        </button>
      </div>
      <SyntaxHighlighter
        language={match?.[1] || "text"}
        style={oneDark}
        customStyle={{
          margin: 0,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomLeftRadius: 8,
          borderBottomRightRadius: 8,
          background: "rgba(0,0,0,0.7)",
          border: "1px solid rgba(255,255,255,0.05)",
          fontSize: 13,
        }}
      >
        {text}
      </SyntaxHighlighter>
    </div>
  );
}

export default function Markdown({ children }) {
  return (
    <div className="prose-chat">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ code: CodeBlock }}>
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
